export const navigationData = [
  { id: 1, title: 'Home', slug: '/' },
  { id: 2, title: 'Directors', slug: '/directors/' },
  { id: 3, title: 'Photographers', slug: '/photographers/' },
  { id: 4, title: 'Zero Factory AI Division', slug: '/directors/zero-factory-ai-division/' },
  // { id: 5, title: 'Beauty Photographers', slug: '/beauty-photographers/' },
  // { id: 6, title: 'Guest Directors', slug: '/guest-directors/' },
  { id: 7, title: 'About', slug: '/about/' },
  { id: 8, title: 'Contacts', slug: '/contacts/' },
];
